import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
    // Organizations
    {
        path: "/administration/maintenances/organizations",
        name: "GetAllOrganizations",
        meta: { title: "Empresas" },
        component: () => import(/* webpackChunkName: "organization" */ "../views/Organizations/GetAllOrganizationsView.vue"),
    },
    {
        path: "/administration/maintenances/organizations/new",
        name: "NewOrganization",
        meta: { title: "Empresas" },
        component: () => import(/* webpackChunkName: "organization" */ "../views/Organizations/GetOrganizationView.vue"),
    },
    {
        path: "/administration/maintenances/organizations/:id",
        name: "ViewOrganization",
        meta: { title: "Empresas" },
        component: () => import(/* webpackChunkName: "organization" */ "../views/Organizations/GetOrganizationView.vue"),
    },
    {
        path: "/administration/maintenances/organizations/:id/edit",
        name: "EditOrganization",
        meta: { title: "Empresas" },
        component: () => import(/* webpackChunkName: "organization" */ "../views/Organizations/GetOrganizationView.vue"),
    },

    // Agencies
    {
        path: "/administration/maintenances/agencies",
        name: "GetAllAgencies",
        meta: { title: "Agencias" },
        component: () =>
            import(/* webpackChunkName: "agency" */ "../views/Agencies/GetAllAgenciesView.vue"),
    }, {
        path: "/administration/maintenances/agencies/new",
        name: "NewAgency",
        meta: { title: "Agencias" },
        component: () =>
            import(/* webpackChunkName: "agency" */ "../views/Agencies/GetAgencyView.vue"),
    }, {
        path: "/administration/maintenances/agencies/:id",
        name: "ViewAgency",
        meta: { title: "Agencias" },
        component: () =>
            import(/* webpackChunkName: "agency" */ "../views/Agencies/GetAgencyView.vue"),
    }, {
        path: "/administration/maintenances/agencies/:id/edit",
        name: "EditAgency",
        meta: { title: "Agencias" },
        component: () =>
            import(/* webpackChunkName: "agency" */ "../views/Agencies/GetAgencyView.vue"),
    },
    {
        path: "/administration/maintenances/series",
        name: "GetAllSeries",
        meta: { title: "Series de facturación" },
        component: () =>
            import(/* webpackChunkName: "series" */ "../views/Series/GetAllSeriesView.vue"),
    }, {
        path: "/administration/maintenances/series/new",
        name: "NewSeries",
        meta: { title: "Series de facturación" },
        component: () =>
            import(/* webpackChunkName: "series" */ "../views/Series/GetSeriesView.vue"),
    }, {
        path: "/administration/maintenances/series/:id",
        name: "ViewSeries",
        meta: { title: "Series de facturación" },
        component: () =>
            import(/* webpackChunkName: "series" */ "../views/Series/GetSeriesView.vue"),
    }, {
        path: "/administration/maintenances/series/:id/edit",
        name: "EditSeries",
        meta: { title: "Series de facturación" },
        component: () =>
            import(/* webpackChunkName: "series" */ "../views/Series/GetSeriesView.vue"),
    }, {
        path: "/administration/invoicing/sales-invoices",
        name: "GetAllSalesInvoices",
        meta: { title: "Facturas de venta" },
        component: () =>
            import(/* webpackChunkName: "salesinvoice" */ "../views/SalesInvoices/GetAllSalesInvoicesView.vue"),
    }, {
        path: "/administration/invoicing/sii-invoices",
        name: "GetSiiSalesInvoices",
        meta: { title: "SII" },
        component: () =>
            import(/* webpackChunkName: "salesinvoice" */ "../views/Invoices/GetSiiInvoicesView.vue"),
    }, {
        path: "/administration/invoicing/sales-invoices/new",
        name: "NewSalesInvoice",
        meta: { title: "Facturas de venta" },
        component: () =>
            import(/* webpackChunkName: "salesinvoice" */ "../views/SalesInvoices/GetSalesInvoiceView.vue"),
    }, {
        path: "/administration/invoicing/sales-invoices/:id",
        name: "ViewSalesInvoice",
        meta: { title: "Facturas de venta" },
        component: () =>
            import(/* webpackChunkName: "salesinvoice" */ "../views/SalesInvoices/GetSalesInvoiceView.vue"),
    }, {
        path: "/administration/invoicing/sales-invoices/:id/edit",
        name: "EditSalesInvoice",
        meta: { title: "Facturas de venta" },
        component: () =>
            import(/* webpackChunkName: "salesinvoice" */ "../views/SalesInvoices/GetSalesInvoiceView.vue"),
    }, {
        path: "/administration/settlements/agencies",
        name: "AgencySettlement",
        meta: { title: "Liquidaciones de agencias" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/AgencySettlementView.vue"),
    },
    {
        path: "/administration/settlements/budgets",
        name: "BudgetSettlement",
        meta: { title: "Liquidaciones de grupos" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/BudgetSettlementView.vue"),
    },
    {
        path: "/administration/maintenances/taxes",
        name: "GetAllTaxes",
        meta: { title: "Impuestos" },
        component: () =>
            import(/* webpackChunkName: "tax" */ "../views/Taxes/GetAllTaxesView.vue"),
    }, {
        path: "/administration/maintenances/taxes/new",
        name: "NewTax",
        meta: { title: "Impuestos" },
        component: () =>
            import(/* webpackChunkName: "tax" */ "../views/Taxes/GetTaxView.vue"),
    }, {
        path: "/administration/maintenances/taxes/:id",
        name: "ViewTax",
        meta: { title: "Impuestos" },
        component: () =>
            import(/* webpackChunkName: "tax" */ "../views/Taxes/GetTaxView.vue"),
    }, {
        path: "/administration/maintenances/taxes/:id/edit",
        name: "EditTax",
        meta: { title: "Impuestos" },
        component: () =>
            import(/* webpackChunkName: "tax" */ "../views/Taxes/GetTaxView.vue"),
    }, {
        path: "/administration/maintenances/settlement-rules",
        name: "GetAllSettlementRules",
        meta: { title: "Reglas de liquidación" },
        component: () =>
            import(/* webpackChunkName: "settlementrule" */ "../views/SettlementRules/GetAllSettlementRulesView.vue"),
    }, {
        path: "/administration/maintenances/settlement-rules/new",
        name: "NewSettlementRule",
        meta: { title: "Reglas de liquidación" },
        component: () =>
            import(/* webpackChunkName: "settlementrule" */ "../views/SettlementRules/GetSettlementRuleView.vue"),
    }, {
        path: "/administration/maintenances/settlement-rules/:id",
        name: "ViewSettlementRule",
        meta: { title: "Reglas de liquidación" },
        component: () =>
            import(/* webpackChunkName: "settlementrule" */ "../views/SettlementRules/GetSettlementRuleView.vue"),
    }, {
        path: "/administration/maintenances/settlement-rules/:id/edit",
        name: "EditSettlementRule",
        meta: { title: "Reglas de liquidación" },
        component: () =>
            import(/* webpackChunkName: "settlementrule" */ "../views/SettlementRules/GetSettlementRuleView.vue"),
    }
    , {
        path: "/administration/settlements/operators",
        name: "OperatorSettlement",
        meta: { title: "Liquidación de operadores" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/OperatorSettlementView.vue"),
    }
    , {
        path: "/administration/settlements/carriers",
        name: "CarrierSettlement",
        meta: { title: "Liquidación de transportistas" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/CarrierSettlementView.vue"),
    }
    , {
        path: "/administration/settlements/providers",
        name: "ProviderSettlement",
        meta: { title: "Liquidación de proveedores" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/ProviderSettlementView.vue"),
    }
    , {
        path: "/administration/settlements/guides",
        name: "GuideSettlement",
        meta: { title: "Liquidación de guías" },
        component: () =>
            import(/* webpackChunkName: "settlement" */ "../views/Billing/GuideSettlementView.vue"),
    }
    , {
        path: "/administration/invoicing/purchase-invoices",
        name: "GetAllPurchaseInvoices",
        meta: { title: "Facturas de compra" },
        component: () =>
            import(/* webpackChunkName: "purchaseinvoice" */ "../views/PurchaseInvoices/GetAllPurchaseInvoicesView.vue"),
    }, {
        path: "/administration/invoicing/purchase-invoices/new",
        name: "NewPurchaseInvoice",
        meta: { title: "Facturas de compra" },
        component: () =>
            import(/* webpackChunkName: "purchaseinvoice" */ "../views/PurchaseInvoices/GetPurchaseInvoiceView.vue"),
    }, {
        path: "/administration/invoicing/purchase-invoices/:id",
        name: "ViewPurchaseInvoice",
        meta: { title: "Facturas de compra" },
        component: () =>
            import(/* webpackChunkName: "purchaseinvoice" */ "../views/PurchaseInvoices/GetPurchaseInvoiceView.vue"),
    }, {
        path: "/administration/invoicing/purchase-invoices/:id/edit",
        name: "EditPurchaseInvoice",
        meta: { title: "Facturas de compra" },
        component: () =>
            import(/* webpackChunkName: "purchaseinvoice" */ "../views/PurchaseInvoices/GetPurchaseInvoiceView.vue"),
    }
    , {
        path: "/administration/maintenances/guide-rates",
        name: "GetAllGuideRates",
        meta: { title: "Tarifas de guía" },
        component: () =>
            import(/* webpackChunkName: "guiderate" */ "../views/GuideRates/GetAllGuideRatesView.vue"),
    }, {
        path: "/administration/maintenances/guide-rates/new",
        name: "NewGuideRate",
        meta: { title: "Tarifas de guía" },
        component: () =>
            import(/* webpackChunkName: "guiderate" */ "../views/GuideRates/GetGuideRateView.vue"),
    }, {
        path: "/administration/maintenances/guide-rates/:id",
        name: "ViewGuideRate",
        meta: { title: "Tarifas de guía" },
        component: () =>
            import(/* webpackChunkName: "guiderate" */ "../views/GuideRates/GetGuideRateView.vue"),
    }, {
        path: "/administration/maintenances/guide-rates/:id/edit",
        name: "EditGuideRate",
        meta: { title: "Tarifas de guía" },
        component: () =>
            import(/* webpackChunkName: "guiderate" */ "../views/GuideRates/GetGuideRateView.vue"),
    },
];


export default routes;
